import { ApiError, ParamsNotFoundError } from '../../helpers/definedErrors';
import { api } from '../../config';

export const uploadSessionPhoto = async (photo, params = null) => {
  if (!params) {
    params = JSON.parse(sessionStorage.getItem('spParams'));
    if (!params) {
      console.error('No params were found!');
      throw new ParamsNotFoundError();
    }
  }
  try {
    const formData = new FormData();
    formData.append('type', photo.type);
    formData.append('photo', photo.src);
    const url = `v1/installs/${params.installSid}/exams/${params.examSid}/sessions/${params.sessionSid}/photos`;
    const headers = {
      token: params.token,
    };
    const response = await api.put(url, headers, formData);
    return response.data;
  } catch (error) {
    console.log('Error uploading session photo', { error });
    throw new ApiError();
  }
};
